import React from 'react';
import { LangSelectProfile } from 'config';
import { components, DropdownIndicatorProps } from 'react-select';

export const CustomDropdownIndicator =
  (children: JSX.Element, dropWithAction: boolean) =>
  (props: DropdownIndicatorProps<LangSelectProfile>) => {
    return dropWithAction ? (
      <components.DropdownIndicator {...props} {...children} />
    ) : (
      children
    );
  };
